/**
 * Canonicalizes a generated-app URL before it is opened in a tab.
 *
 * The web server hosting generated apps answers the slash-less directory form
 * with an absolute redirect whose scheme is plain http (TLS terminates at the
 * load balancer in front of it): https://host/app → 301 http://host/app/.
 * Chrome auto-upgrades that downgrade back to https; Safari follows it to
 * port 80, which resets the connection — "Safari Can't Open the Page — the
 * server unexpectedly dropped the connection" (KOA-17913). Requesting the
 * canonical form directly avoids the redirect: appends the trailing slash to
 * extension-less paths and forces https while the designer itself is served
 * over https.
 */
export function normalizePreviewUrl(rawUrl: string, pageProtocol: string = window.location.protocol): string {
  if (!rawUrl) {
    return rawUrl;
  }
  let parsed: URL;
  try {
    parsed = new URL(rawUrl);
  } catch {
    return rawUrl;
  }
  if (pageProtocol === "https:" && parsed.protocol === "http:") {
    parsed.protocol = "https:";
  }
  const lastSegment: string = parsed.pathname.split("/").pop() ?? "";
  if (!parsed.pathname.endsWith("/") && !lastSegment.includes(".")) {
    parsed.pathname = `${parsed.pathname}/`;
  }
  return parsed.toString();
}
